import React from "react";

const GTPrfqs = () => {

    return (
        <div className="buyer-dashboard">
            <div className="text">Welcome to Amtpl GTP RFQs page</div>


        </div>
    );
};

export default GTPrfqs